import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Carousel = ({ images, testid = "carousel" }) => {
    const [index, setIndex] = useState(0);
    const [paused, setPaused] = useState(false);
    const count = images.length;
    const prev = () => setIndex((i) => (i - 1 + count) % count);
    const next = () => setIndex((i) => (i + 1) % count);

    useEffect(() => {
        if (paused || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const timer = setInterval(() => setIndex((i) => (i + 1) % count), 4500);
        return () => clearInterval(timer);
    }, [paused, count, index]);

    return (
        <div
            data-testid={testid}
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            onFocus={() => setPaused(true)}
            onBlur={() => setPaused(false)}
        >
            <div className="relative overflow-hidden border border-bronze/15">
                <div
                    className="flex transition-transform duration-500 ease-out"
                    style={{ transform: `translateX(-${index * 100}%)` }}
                >
                    {images.map((img, i) => (
                        <img
                            key={img.src}
                            src={img.src}
                            alt={img.alt}
                            loading={i === 0 ? "eager" : "lazy"}
                            data-testid={`${testid}-image-${i}`}
                            className="aspect-[4/5] w-full shrink-0 object-cover sm:aspect-[5/5]"
                        />
                    ))}
                </div>
                <button
                    type="button"
                    onClick={prev}
                    aria-label="Previous image"
                    data-testid={`${testid}-prev`}
                    className="absolute left-3 top-1/2 -translate-y-1/2 bg-charcoal/70 p-2 text-cream transition-colors duration-300 hover:bg-bronze"
                >
                    <ChevronLeft size={20} aria-hidden="true" />
                </button>
                <button
                    type="button"
                    onClick={next}
                    aria-label="Next image"
                    data-testid={`${testid}-next`}
                    className="absolute right-3 top-1/2 -translate-y-1/2 bg-charcoal/70 p-2 text-cream transition-colors duration-300 hover:bg-bronze"
                >
                    <ChevronRight size={20} aria-hidden="true" />
                </button>
            </div>
            <div className="mt-4 flex items-center justify-center gap-2" role="tablist" aria-label="Choose image">
                {images.map((img, i) => (
                    <button
                        key={img.src}
                        type="button"
                        onClick={() => setIndex(i)}
                        aria-label={`Show image ${i + 1}`}
                        aria-current={i === index}
                        data-testid={`${testid}-dot-${i}`}
                        className={`h-1.5 transition-all duration-300 ${
                            i === index ? "w-8 bg-bronze" : "w-3 bg-charcoal/25 hover:bg-bronze/50"
                        }`}
                    />
                ))}
            </div>
        </div>
    );
};

export default Carousel;
